import {
  ProductAssetsDrawerCarouselImportedTabPanel,
  ProductAssetsDrawerCarouselSparkTabPanel,
  ProductAssetsDrawerCarouselTabPanel,
  ProductAssetsDrawer as ProductAssetsDrawerComponent,
  ProductAssetsDrawerContent,
  type ProductAssetsDrawerContentProps,
  ProductAssetsDrawerHeroImportedTabPanel,
  ProductAssetsDrawerHeroSparkTabPanel,
  ProductAssetsDrawerHeroTabPanel,
  type ProductAssetsDrawerProps,
  ProductAssetsDrawerTrigger,
} from './product-assets-drawer';

/**
 * A product assets drawer component.
 * @param props - The props for the product assets drawer.
 * @returns The product assets drawer component.
 *
 * @example
 *   <ProductAssetsDrawer {...args}>
 *     <div className="flex flex-col gap-4 p-8 h-screen">
 *       <div>
 *         <ProductAssetsDrawer.Trigger>
 *           <Button level={ButtonLevel.Secondary} iconStart={<Image01Icon />}>
 *             Product Assets
 *           </Button>
 *         </ProductAssetsDrawer.Trigger>
 *       </div>
 *     </div>
 *     <ProductAssetsDrawer.Content>
 *       <ProductAssetsDrawer.HeroTabPanel>Hero Tab Panel</ProductAssetsDrawer.HeroTabPanel>
 *       <ProductAssetsDrawer.CarouselTabPanel>Carousel Tab Panel</ProductAssetsDrawer.CarouselTabPanel>
 *     </ProductAssetsDrawer.Content>
 *   </ProductAssetsDrawer>
 */
const ProductAssetsDrawer = Object.assign(ProductAssetsDrawerComponent, {
  Content: ProductAssetsDrawerContent,
  HeroTabPanel: ProductAssetsDrawerHeroTabPanel,
  CarouselTabPanel: ProductAssetsDrawerCarouselTabPanel,
  Trigger: ProductAssetsDrawerTrigger,
});

export {
  ProductAssetsDrawer,
  ProductAssetsDrawerCarouselImportedTabPanel,
  ProductAssetsDrawerCarouselSparkTabPanel,
  ProductAssetsDrawerHeroImportedTabPanel,
  ProductAssetsDrawerHeroSparkTabPanel,
};
export type { ProductAssetsDrawerProps, ProductAssetsDrawerContentProps };
